import TypeError from '.TypeError';

import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';
import Property from './Declaration';

export default class Properties extends Layer           {
	
	get [Symbol.toStringTag] () { return 'Properties'; }
	
	constructor (parent                           ) {
		super();
		this[TOKEN.parent] = parent;
		return this;
	}
	
	[TOKEN.consume] (                ) {
		switch ( TOKEN.type ) {
			case TOKEN.whitespace:
			case TOKEN.comment:
				return this;
			case TOKEN.ident:
				return this.newItem = new Property(TOKEN.literal);
			case '}':
				return this[TOKEN.parent][TOKEN.parent];
		}
		return null;
	}
	
	[Symbol.toPrimitive] (                ) {
		return this.join('');
	}
	
	* [Symbol.iterator] (                ) { throw TypeError(`beautify properties`); }
	
	                                                  
	
	static default = protect(this);
	
};

                                                 
                                         